import LogoutOutlined from '@ant-design/icons/lib/icons/LogoutOutlined'
import SettingOutlined from '@ant-design/icons/lib/icons/SettingOutlined'
import UserOutlined from '@ant-design/icons/lib/icons/UserOutlined'
import { Avatar, Dropdown, Flex, MenuProps, Typography } from 'antd'
import { FC } from 'react'
import { useAppDispatch, useAppSelector, resetAllApiStates } from '../../../store/store'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../../constants/routes'
import { resetAuth } from '../../../store/auth/auth'
import { useUser } from '../../../hooks/use-user'

interface UserProps {}

const User: FC<UserProps> = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: 'Аккаунт',
            onClick() {
                navigate(routes.profile)
            },
        },
        {
            type: 'divider',
        },
        {
            key: '3',
            label: 'Настройки',
            icon: <SettingOutlined />,
        },
        {
            key: '4',
            label: 'Выйти',
            icon: <LogoutOutlined />,
            onClick() {
                resetAllApiStates()
                dispatch(resetAuth())
                navigate(routes.login)
            },
        },
    ]

    const user = useUser()

    return (
        <Dropdown menu={{ items }}>
            <Flex gap={12} align={'center'}>
                <Avatar icon={<UserOutlined />} />
                <Typography.Text>{user?.username}</Typography.Text>
            </Flex>
        </Dropdown>
    )
}

export default User
